import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListCheck24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconListCheck24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.96 6.116a.75.75 0 0 1 0 1.06l-2.998 3-.53.53-.531-.53-1.5-1.5a.75.75 0 1 1 1.061-1.06l.97.969L6.9 6.115a.75.75 0 0 1 1.06 0m-2.305 7.729H4a.5.5 0 0 0-.5.5V16a.5.5 0 0 0 .5.5h1.655a.5.5 0 0 0 .5-.5v-1.655a.5.5 0 0 0-.5-.5M4 12.345a2 2 0 0 0-2 2V16a2 2 0 0 0 2 2h1.655a2 2 0 0 0 2-2v-1.655a2 2 0 0 0-2-2zM22.13 6.75a.75.75 0 0 1-.75.75h-9.812a.75.75 0 1 1 0-1.5h9.811a.75.75 0 0 1 .75.75m-2.265 3.5a.75.75 0 0 1-.75.75h-7.547a.75.75 0 0 1 0-1.5h7.547a.75.75 0 0 1 .75.75m1.514 4.25a.75.75 0 0 0 0-1.5h-9.81a.75.75 0 1 0 0 1.5zm-1.514 2.75a.75.75 0 0 1-.75.75h-7.547a.75.75 0 0 1 0-1.5h7.547a.75.75 0 0 1 .75.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListCheck24);
